import { useContext } from "react";
import { DetailsPageTopControlsView } from "../common/panels/misc/DetailsPageTopControlsView/DetailsPageTopControlsView";
import { SessionContext } from "../common/contexts/SessionContext";
import { NotSet } from "../common/misc/UIconstants";
import Detail from "../common/panels/Detail/Detail";
import { Table } from "../common/panels/Detail/DetailTable";
import { MoreDropdown } from "../common/buttons/MoreDropdown/MoreDropdown";
import { PersonsTile } from "../common/sidebar/tiles/PersonsTile";
import { PermissionsTable } from "../Permissions/PermissionsTable";
import { EntityDetailProps, EntityDetailTableProps } from "../common/entity/EntityInterfaces";
import { EntityDeleteButton } from "../Entities/GenericComponents/common/GenericEntityDetailPage";
import { EntityEditButton } from "../common/entity/entityComponents/EntityEditButton";
import { EntityCloneButton } from "../common/entity/entityComponents/EntityCloneButton";

export const RolesDetailTable = ({ entity, entityConstants, fieldLabels }: EntityDetailTableProps<"roles">) => {
  const { session } = useContext(SessionContext);
  return (
    <>
      <Table noPadding nonFoldable>
        <Table.Head>Details</Table.Head>
        <Table.Body>
          <Table.Body.RowContent title={fieldLabels.name} content={entity.name} />

          <Table.Body.RowContent
            title={fieldLabels.description}
            content={
              <>
                {entity.description ? (
                  <div className="container_notes">
                    <textarea rows={4} className="container_textarea" value={entity?.description} disabled />
                  </div>
                ) : (
                  NotSet
                )}
              </>
            }
          />
        </Table.Body>
      </Table>

      {(session?.permissions.logsadmin || session?.permissions.view_admin_pages) && (
        <Table noPadding>
          <Table.Head>{fieldLabels.rolePermissions}</Table.Head>
          <Table.Body>
            <PermissionsTable permissionsOverride={entity.rolePermissions} />
          </Table.Body>
        </Table>
      )}
    </>
  );
};

export const RolesDetail = ({
  permissions,
  routes,
  entity,
  entityApi,
  entityConstants,
  fieldLabels,
  entityTypeId,
}: EntityDetailProps<"roles">) => {
  const { session } = useContext(SessionContext);

  return (
    <Detail
      head={
        <DetailsPageTopControlsView
          entityTypeId={entityTypeId}
          entity={entity}
          entityConstants={entityConstants}
          hideHistoryModal={entity.isDefault}
          controls={
            session?.permissions.logsadmin ? (
              <>
                <EntityEditButton
                  entity={entity}
                  entityConstants={entityConstants}
                  permissions={permissions}
                  routes={routes}
                  disabledOverride={!entity.permissions?.canEdit || entity.isDefault || entity.isInternal}
                />
                <MoreDropdown drop="right" btn="btn btn-ghost-secondary">
                  <li>
                    <EntityCloneButton
                      entity={entity}
                      entityConstants={entityConstants}
                      routes={routes}
                      permissions={permissions}
                    />
                  </li>
                  <li className="divider" />
                  <li>
                    <EntityDeleteButton entity={entity} entityTypeId={entityTypeId} alwaysDeletePermanently />
                  </li>
                </MoreDropdown>
              </>
            ) : undefined
          }
        />
      }
      mainStyle={{ padding: "0px 10px" }}
      main={
        <RolesDetailTable
          entity={entity}
          entityConstants={entityConstants}
          fieldLabels={fieldLabels}
          entityTypeId={entityTypeId}
        />
      }
      sidebar={
        <>
          <PersonsTile defaultFilters={{ roleIds: [entity.id] }} excludeFilters={{ roleIds: () => false }} />
        </>
      }
    />
  );
};
